import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE,

    ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE,

    ITrialInstitutionLaboratoryPersonnelsLoadAction,
    ITrialInstitutionLaboratoryPersonnelLoadByIdAction,
    ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdAction,
    ITrialInstitutionLaboratoryPersonnelLoadFailureAction,
    ITrialInstitutionLaboratoryPersonnelLoadSuccessAction,

    ITrialInstitutionLaboratoryPersonnelSaveAction,
    ITrialInstitutionLaboratoryPersonnelSaveSuccessAction,
    ITrialInstitutionLaboratoryPersonnelSaveFailureAction,

    ITrialInstitutionLaboratoryPersonnelCreateAction,
    ITrialInstitutionLaboratoryPersonnelCreateSuccessAction,
    ITrialInstitutionLaboratoryPersonnelCreateFailureAction,

    ITrialInstitutionLaboratoryPersonnelValidateAction,
    ITrialInstitutionLaboratoryPersonnelValidateSuccessAction,
    ITrialInstitutionLaboratoryPersonnelValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionLaboratoryPersonnels";
import { trialInstitutionLaboratoryPersonnelsApi } from "../services/trialInstitutionLaboratoryPersonnels";


export const
    getTrialInstitutionLaboratoryPersonnelsEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelLoadSuccessAction | ITrialInstitutionLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD)
            .mergeMap((_action: ITrialInstitutionLaboratoryPersonnelsLoadAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .getTrialInstitutionLaboratoryPersonnels()
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryPersonnels, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryPersonnelByIdEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelLoadSuccessAction | ITrialInstitutionLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryPersonnelLoadByIdAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .getTrialInstitutionLaboratoryPersonnelById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryPersonnelByLaboratoryIdEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelLoadSuccessAction | ITrialInstitutionLaboratoryPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryPersonnelLoadByLaboratoryIdAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .getTrialInstitutionLaboratoryPersonnelByLaboratoryId(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratoryPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionLaboratoryPersonnelEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelSaveSuccessAction | ITrialInstitutionLaboratoryPersonnelSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_SAVE)
            .mergeMap((action: ITrialInstitutionLaboratoryPersonnelSaveAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .setTrialInstitutionLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionLaboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionLaboratoryPersonnelEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelCreateSuccessAction | ITrialInstitutionLaboratoryPersonnelCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_CREATE)
            .mergeMap((action: ITrialInstitutionLaboratoryPersonnelCreateAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .createTrialInstitutionLaboratoryPersonnel(action.trialInstitutionLaboratoryId)
                    .map(response =>
                        CreateSuccess(response.trialInstitutionLaboratoryPersonnel, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionLaboratoryPersonnelEpic = (action$): Observable<ITrialInstitutionLaboratoryPersonnelValidateSuccessAction | ITrialInstitutionLaboratoryPersonnelValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORYPERSONNEL_VALIDATE)
            .mergeMap((action: ITrialInstitutionLaboratoryPersonnelValidateAction) => {
                return trialInstitutionLaboratoryPersonnelsApi
                    .validateTrialInstitutionLaboratoryPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionLaboratoryPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }